<template>
  <EListItem
    :data-test-id="`flight-suggestion-${iataCode}`"
    data-track-id="flight-suggestion"
    class="flight-booking-form__suggestion"
    role="menuitem"
    v-on="$listeners"
  >
    <strong>
      {{ title }}
    </strong>
    <br>
    {{ subtitle }}
  </EListItem>
</template>

<script>
import EListItem from '~~/common/vue/components/list-item';

export default {
  components: {
    EListItem,
  },
  props: {
    // It's not certain that any of these fields is present in the data.
    iataCode: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    cityName: {
      type: String,
      default: '',
    },
    countryName: {
      type: String,
      default: '',
    },
    /**
     * List of location names separated by |
     * e.g. Frankfurt|Hesse|Germany
     * When multi-line, lines are separated by a comma
     * e.g. Paris Charles de Gaulle (CDG), Paris|Île-de-France|France
     * The format is Name (IATA Code), Location
     *
     * @TODO: remove this prop if we decide not to do highlighting.
     */
    hierarchy: {
      type: String,
      default: '',
    },
    /**
     * Highlighting positions are provided to highlight the searched terms.
     * These positions are applied to the hierarchy prop.
     * It's also possible to use them in the name prop,
     * being aware that some positions might be out-of-bounds.
     *
     * @TODO: remove this prop if we decide not to do highlighting.
     */
    highlighting: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    title() {
      return [this.iataCode, this.name].filter(Boolean).join(' - ');
    },
    subtitle() {
      return [this.cityName, this.countryName].filter(Boolean).join(', ');
    },
  },
};
</script>
<style lang="scss" scoped>
.list-item {
  padding: $space-1l $space-m;
}
</style>
